export interface GossipItem {
  id: number;
  category: string;
  title: string;
  summary: string;
  time: string;
  views: string;
  heat: number;
  tag: string;
  image: string;
  content: string[];
}

export const categories = ['全部', '明星', '影视', '综艺', '音乐', '电竞', '社会'];

export const feed: GossipItem[] = [
  {
    id: 1,
    category: '明星',
    title: '人气演员林一舟片场路透曝光，下班手里还不忘端着一碗面',
    summary: '路透画面里林一舟边收工边嗦面，网友笑称"这才是真·吃瓜cb配饭下饭"，敬业又接地气，边吃边看更带劲。',
    time: '12分钟前',
    views: '38.6万',
    heat: 96,
    tag: '热搜爆',
    image: 'https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20young%20male%20celebrity%20smiling%20with%20a%20bowl%20of%20noodles%20at%20a%20film%20set%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20playful%20flat%20art%2C%20clean%20simple%20background%2C%20vibrant%20appetizing%20food%20vibe&width=800&height=600&seq=feed-star-01&orientation=landscape',
    content: [
      '最近人气演员林一舟的一组片场路透悄悄传开，画面里他刚结束当天拍摄，收工时手上还端着一碗热腾腾的面条，边走边吃，脸上挂着满足的笑，完全没有偶像包袱。',
      '这组画面一出，粉丝们纷纷在评论区留言，直呼他太接地气，还有人玩梗说"原来当红炸子鸡的下班仪式感，就是一口热乎饭配一口新鲜瓜"。评论区瞬间热闹起来，转发量也在持续攀升。',
      '工作室随后低调回应，称林一舟平时确实爱在片场备点简餐，觉得边吃边回看当天表演、刷刷热点很放松。这种真实的一面反而让不少路人好感度直线上升。',
    ],
  },
  {
    id: 2,
    category: '影视',
    title: '年末黑马剧《巷口烟火》口碑发酵，连配角都成下饭谈资',
    summary: '没有大流量阵容的《巷口烟火》凭扎实剧本出圈，观众一边吃饭一边追更，边吃边看真香现场名不虚传。',
    time: '38分钟前',
    views: '52.1万',
    heat: 94,
    tag: '口碑',
    image: 'https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20of%20a%20cozy%20chinese%20street%20alley%20restaurant%20with%20warm%20lanterns%20and%20steaming%20food%20at%20dusk%2C%20warm%20orange%20cream%20flat%20art%2C%20clean%20minimal%20background%2C%20story%20drama%20mood&width=800&height=600&seq=feed-movie-02&orientation=landscape',
    content: [
      '今年年末播出的现实题材剧《巷口烟火》没有依赖流量阵容，却凭借扎实的剧本和细腻的群像演技悄悄爬上了口碑榜。很多观众把它列进了"配饭必看清单"。',
      '剧中那条满是烟火气的巷子，做饭、吵嘴、和解的场景自然又真实，看一集就像真的端碗坐在巷口，边吃边看格外上头。不少剧评人认为它是今年最被低估的一部。',
      '目前该剧豆瓣评分仍在缓慢上涨，官方也顺势放出了幕后花絮，正片加花絮的双重福利，让不少原本只是路过的观众也入了坑。',
    ],
  },
  {
    id: 3,
    category: '综艺',
    title: '《深夜食堂常驻位》开播即爆，明星下厨翻车名场面被疯传',
    summary: '新综艺让嘉宾现场开火，翻车现场一个比一个精彩，弹幕全是"下饭神器"，边吃边看真香现场实锤。',
    time: '1小时前',
    views: '45.3万',
    heat: 91,
    tag: '新综',
    image: 'https://readdy.ai/api/search-image?query=playful%20stylized%20illustration%20of%20chefs%20and%20celebrities%20cooking%20in%20a%20bright%20tv%20kitchen%20studio%2C%20flying%20vegetables%20and%20steam%2C%20warm%20orange%20gold%20flat%20art%2C%20clean%20simple%20background%2C%20fun%20chaotic%20energy&width=800&height=600&seq=feed-show-03&orientation=landscape',
    content: [
      '新上线的慢综艺《深夜食堂常驻位》请来几位嘉宾轮流掌勺，本来是想走治愈路线，结果开播第一期就贡献了教科书级的翻车现场：盐和糖拿错、锅盖被掀飞、切菜切到案板……',
      '弹幕里"下饭神器""笑不活了"刷个不停，相关片段在短视频平台被疯狂转发，播放量半天就破了千万。观众表示，看着别人手忙脚乱，自己碗里的饭都香了。',
      '节目组顺势把这些名场面做成了合集，还玩梗喊话观众"下饭需谨慎，小心喷饭"。这种松弛又真实的氛围，正是当下综艺最稀缺的东西。',
    ],
  },
  {
    id: 4,
    category: '音乐',
    title: '新锐歌手阿澈首支原创单曲上线，民谣里藏满烟火气',
    summary: '把街边小面馆写进歌里的阿澈，用一首温暖民谣治愈无数夜归人，边吃边看、听完就想来一碗热汤。',
    time: '2小时前',
    views: '27.9万',
    heat: 82,
    tag: '新歌',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20young%20male%20singer%20with%20acoustic%20guitar%20near%20a%20warm%20night%20noodle%20stall%20street%2C%20warm%20amber%20and%20cream%20flat%20art%2C%20cozy%20minimal%20background%2C%20folk%20music%20mood&width=800&height=600&seq=feed-music-04&orientation=landscape',
    content: [
      '从街头唱到舞台的新锐歌手阿澈，最近发布了自己第一支原创单曲《巷口的那碗热汤》。歌里没有华丽的辞藻，却把街角小面馆、夜归人、热汤冒起的白气唱得格外动人。',
      '上线当晚，歌曲评论区就被深夜听众占领。有人说听着歌把冷掉的饭又热了一遍，有人说单曲循环后决定下楼吃碗面。这种来自生活里的真实烟火气，意外成了它最大的记忆点。',
      '业内人士评价，阿澈难得地把"接地气"做成了高级感。目前歌曲在各音乐平台的收藏量还在稳步上涨，成为近期难得的一支治愈系黑马。',
    ],
  },
  {
    id: 5,
    category: '电竞',
    title: 'LPL春季赛季后赛名单落定，老牌战队压轴晋级引热议',
    summary: '一场跌宕起伏的BO5把粉丝心提到嗓子眼，网友边嗑瓜子边复盘，边吃边看真香现场进度已拉满。',
    time: '3小时前',
    views: '61.4万',
    heat: 97,
    tag: '热搜爆',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20stylized%20illustration%20of%20an%20esports%20arena%20with%20glowing%20screens%20and%20excited%20crowd%2C%20warm%20orange%20and%20gold%20flat%20art%2C%20clean%20minimal%20background%2C%20competitive%20energy&width=800&height=600&seq=feed-esport-05&orientation=landscape',
    content: [
      '今年的季后赛名额争夺战可谓一波三折。作为老牌劲旅的FPG战队在决胜局连追三场，硬生生把赛点夺了回来，最终压轴锁定最后一个晋级席位。',
      '整场BO5打得荡气回肠，观赛间里弹幕就没停过。不少平时不太看比赛的路人也被这出反转大戏吸引，端着碗坐在电脑前看到最后一刻。',
      '晋级名单尘埃落定后，各家粉丝已经开始在评论区盘算接下来的对阵。可以预见，后面的每一场淘汰赛都将是新一轮"下饭好戏"。',
    ],
  },
  {
    id: 6,
    category: '社会',
    title: '深夜街边小吃摊走红，老板边颠勺边讲人生故事的视频火了',
    summary: '一个摆摊十几年的老板把"烟火气"演成了连续剧，网友边看边吃，评论区直接成了深夜树洞。',
    time: '5小时前',
    views: '33.2万',
    heat: 78,
    tag: '暖闻',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20street%20food%20stall%20owner%20cooking%20wok%20at%20night%20with%20warm%20steam%20and%20neon%20lights%2C%20warm%20orange%20cream%20flat%20art%2C%20cozy%20minimal%20background%2C%20nocturnal%20life%20mood&width=800&height=600&seq=feed-life-06&orientation=landscape',
    content: [
      '最近有位在巷口摆摊十几年的小吃摊老板火了，起因是网友随手拍下他边颠勺边跟熟客唠嗑的画面。老板讲话带着故事感，一碗炒粉的空当，能讲出一段人生。',
      '视频被转发后，评论区迅速成了大型深夜树洞。有人感叹这才是真正的"烟火气"，有人则说看老板颠勺特别解压，正好下饭。',
      '面对突如其来的关注，老板很淡定，说日子该怎么过还怎么过，能有更多新朋友来尝一口他的手艺就是最大的满足。',
    ],
  },
  {
    id: 7,
    category: '影视',
    title: '经典IP《寻味人生》宣布重启，原班主创回归成最大卖点',
    summary: '十年前的现象级美食剧要拍续集了，消息一出老粉集体沸腾，边吃边看的情怀这下能续上了。',
    time: '8小时前',
    views: '41.8万',
    heat: 89,
    tag: '官宣',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20retro%20chinese%20restaurant%20scene%20with%20family%20dinner%20table%20and%20steaming%20dishes%2C%20nostalgic%20warm%20orange%20cream%20flat%20art%2C%20clean%20background%2C%20heartwarming%20mood&width=800&height=600&seq=feed-movie-07&orientation=landscape',
    content: [
      '十年前的经典美食剧《寻味人生》突然官宣重启，而且确认由当年几大核心主创回归操刀。消息一出，老剧粉们瞬间沸腾，直接把相关话题顶上热搜。',
      '对很多人来说，这部剧不只是一部剧，更是学生时代吃饭时全家围坐追更的记忆。主创回归无疑给这份情怀吃了定心丸。',
      '据悉续集仍将围绕"一道菜、一家人、一段缘"展开，并会加入当下年轻人感兴趣的创新美食题材。开机时间待定，但观众的热情已经先到一步。',
    ],
  },
  {
    id: 8,
    category: '明星',
    title: '实力派视后程砚秋休假被偶遇，素颜逛菜市场毫无架子',
    summary: '程砚秋被拍到拎着菜篮在菜市场挑挑拣拣，网友直呼"这瓜越吃越香"，边吃边看真香现场本人出现了。',
    time: '11小时前',
    views: '30.5万',
    heat: 84,
    tag: '偶遇',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20relaxed%20female%20actress%20holding%20a%20wicker%20basket%20at%20a%20fresh%20vegetable%20market%2C%20warm%20orange%20cream%20flat%20art%2C%20casual%20daily%20life%20mood%2C%20clean%20simple%20background&width=800&height=600&seq=feed-star-08&orientation=landscape',
    content: [
      '凭借多部热播剧站稳脚跟的程砚秋，难得放了个小长假。有网友在菜市场偶遇她，一身素净打扮、素颜出街，正专注地在一堆西红柿前挑挑拣拣。',
      '照片传开后评论区画风出奇一致：一点架子都没有，看着就很亲切。还有人打趣说，视后也是要好好吃饭的普通人。',
      '面对大家的热议，程砚秋在社交平台大方回应，说自己休假最大的爱好就是下厨，逛菜市场特别解压。这番接地气的坦白，又圈了一波好感。',
    ],
  },
];

export interface HotItem {
  rank: number;
  title: string;
  heat: number;
  trend: 'up' | 'down' | 'flat';
}

export const hotList: HotItem[] = [
  { rank: 1, title: 'LPL春季赛老牌战队压轴晋级', heat: 986, trend: 'up' },
  { rank: 2, title: '《巷口烟火》成年末口碑黑马', heat: 941, trend: 'up' },
  { rank: 3, title: '林一舟片场嗦面路透走红', heat: 907, trend: 'up' },
  { rank: 4, title: '程砚秋素颜逛菜市场被偶遇', heat: 862, trend: 'flat' },
  { rank: 5, title: '深夜食堂翻车名场面合集', heat: 838, trend: 'up' },
  { rank: 6, title: '阿澈新歌《巷口的那碗热汤》', heat: 795, trend: 'up' },
  { rank: 7, title: '《寻味人生》确认重启', heat: 742, trend: 'down' },
  { rank: 8, title: '小吃摊老板边颠勺边讲人生', heat: 688, trend: 'flat' },
];

export interface ColumnItem {
  id: number;
  name: string;
  desc: string;
  count: string;
  accent: 'primary' | 'accent' | 'secondary';
  image: string;
}

export const columns: ColumnItem[] = [
  {
    id: 1,
    name: '早八速食瓜',
    desc: '通勤路上五分钟，热门瓜料一网打尽。',
    count: '每日更新',
    accent: 'primary',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20morning%20commute%20person%20scrolling%20phone%20with%20toast%20and%20coffee%2C%20warm%20orange%20cream%20flat%20art%2C%20fresh%20energetic%20mood%2C%20clean%20minimal%20background&width=640&height=640&seq=col-morning&orientation=squarish',
  },
  {
    id: 2,
    name: '深夜下饭盘',
    desc: '夜深人静端碗坐好，治愈系好瓜慢慢吃。',
    count: '深夜 22:00',
    accent: 'accent',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20cozy%20late%20night%20desk%20with%20a%20bowl%20and%20lamp%20glow%2C%20warm%20amber%20cream%20flat%20art%2C%20calm%20relaxing%20mood%2C%20clean%20minimal%20background&width=640&height=640&seq=col-night&orientation=squarish',
  },
  {
    id: 3,
    name: '瓜田档案',
    desc: '把冷掉的瓜挖出来复盘，越挖越上头。',
    count: '深度盘点',
    accent: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20an%20open%20retro%20archive%20folder%20and%20magnifying%20glass%20with%20document%20pages%2C%20warm%20green%20and%20cream%20flat%20art%2C%20curious%20analytical%20mood%2C%20clean%20minimal%20background&width=640&height=640&seq=col-archive&orientation=squarish',
  },
  {
    id: 4,
    name: '瓜友会客厅',
    desc: '你的看法同样重要，来评论区唠个痛快。',
    count: '热聊中',
    accent: 'primary',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20friends%20chatting%20around%20a%20table%20with%20drinks%20and%20phones%2C%20warm%20orange%20cream%20flat%20art%2C%20lively%20friendly%20mood%2C%20clean%20minimal%20background&width=640&height=640&seq=col-lounge&orientation=squarish',
  },
];

export interface RealItem {
  id: number;
  title: string;
  quote: string;
  tag: string;
  image: string;
}

export const realItems: RealItem[] = [
  {
    id: 1,
    title: '一集一集追完才肯放下碗',
    quote: '以前吃饭都是对着手机发呆，现在端着碗等更新，边吃边看真的香，饭都多吃了一碗。',
    tag: '真香用户',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20person%20happily%20eating%20at%20a%20table%20watching%20content%20on%20a%20tablet%2C%20warm%20orange%20cream%20flat%20art%2C%20joyful%20appetizing%20mood%2C%20clean%20cozy%20background&width=1200&height=760&seq=real-bowl-01&orientation=landscape',
  },
  {
    id: 2,
    title: '从早八刷到深夜，越刷越上头',
    quote: '早八速食瓜配咖啡，深夜下饭盘配夜宵，一天不刷浑身难受，吃瓜cb已经是我吃饭的固定搭子了。',
    tag: '铁杆瓜友',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20person%20relaxing%20in%20bed%20at%20night%20scrolling%20phone%20with%20snack%20beside%2C%20warm%20amber%20cream%20flat%20art%2C%20cozy%20relaxed%20mood%2C%20clean%20minimal%20background&width=1200&height=760&seq=real-day-02&orientation=landscape',
  },
  {
    id: 3,
    title: '跟着吃瓜cb，社交话题从不缺席',
    quote: '宿舍夜谈、同事午休，我永远是那个最新瓜的人，感谢吃瓜cb给我配的下饭谈资，边吃边看真香现场名不虚传。',
    tag: '社交达人',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20young%20friends%20laughing%20and%20chatting%20together%20over%20food%20in%20a%20canteen%2C%20warm%20orange%20cream%20flat%20art%2C%20lively%20social%20mood%2C%20clean%20background&width=1200&height=760&seq=real-talk-03&orientation=landscape',
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '吃瓜cb是什么？真的可以配饭下饭吗？',
    a: '吃瓜cb是一个主打"边吃边看"的娱乐资讯平台，每天为你整理热门爆料和轻松话题，内容短平快、分类清晰，特别适合吃饭、通勤等碎片时间边吃边看。选对一部好剧、一个有趣的瓜，米饭都香三分，这就是传说中的下饭真香现场。',
  },
  {
    q: '吃瓜cb的内容多久更新一次？',
    a: '我们保持全天候滚动更新，最热的爆料、热榜和话题都会在第一时间整理上架。同时设有"早八速食瓜""深夜下饭盘"等栏目，让你在不同时段都能刷到对口的内容。',
  },
  {
    q: '吃瓜cb的内容来源可靠吗？',
    a: '吃瓜cb整合的内容均来自公开报道与可查证的信息源，并尽量注明出处、标注时间。我们倡导理性吃瓜、不信谣不传谣，任何未经证实的传闻都会明确标注，帮助大家边吃边看更放心。',
  },
  {
    q: '我能向吃瓜cb投稿或者爆料吗？',
    a: '当然可以。你可以在页面底部的"投稿征集"区留下你的线索和想法，我们会认真阅读每一份投稿。若素材被采用并审核通过，会整理成内容发布并标注来源。',
  },
  {
    q: '吃瓜cb收费吗？需要下载App吗？',
    a: '吃瓜cb目前完全免费，直接在网页打开即可边吃边看，无需下载安装。我们坚持轻量、快速、好用的体验，让你端起碗就能开始今天的"下饭时间"。',
  },
  {
    q: '如何把好瓜分享给朋友一起下饭？',
    a: '每篇内容都支持一键分享到社交平台，你可以把正在看的好瓜转给同样爱吃的朋友。一个人吃饭是干饭，两个人一起边吃边看，才是真香现场的完全体。',
  },
];

export interface VoiceItem {
  nick: string;
  role: string;
  text: string;
  stars: number;
}

export const voices: VoiceItem[] = [
  { nick: '西瓜不吃皮', role: '上班族', text: '午饭不香的时候来吃瓜cb逛一圈，看着看着饭就见底了，稳稳的下饭搭子。', stars: 5 },
  { nick: '夜宵常驻选手', role: '夜猫子', text: '深夜下饭盘简直是为我定制的，配夜宵刚刚好，已连续追更一个月。', stars: 5 },
  { nick: '课间吃瓜人', role: '大学生', text: '宿舍熄灯后轮流端碗看，边吃边看笑到喷饭，已成为全寝室的快乐源泉。', stars: 4 },
];